import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/trap-icon-no-set.svg';

const SnapTrapStatus_NoSet: React.FC = () => {
  return <img src={Icon} height={30} alt="Snap Status No Set" />;
};

export default SnapTrapStatus_NoSet;
